<template>
    <div>
        <v-layout>
            <v-text-field
                v-model="intent"
                :label="$t('intent')"
                prepend-inner-icon="mdi-magnify"
                class="mr-3"
            ></v-text-field>
            <v-text-field
                v-model="entity"
                :label="$t('entity')"
                prepend-inner-icon="mdi-magnify"
                class="mr-3"
            ></v-text-field>
            <v-text-field
                v-model="content"
                :label="$t('content')"
                prepend-inner-icon="mdi-magnify"
                class="mr-3"
            ></v-text-field>
            <v-btn @click="createItem" v-if="isEditable">{{ $t('new') }}</v-btn>
            <v-btn @click="importExcel" v-if="isEditable">{{ $t('import') + ' Excel' }}</v-btn>
        </v-layout>
        <SimpleDataTable
            :headers="sampleHeaders"
            :items="filterSampleList"
            :pagination="pagination"
        >
            <template v-slot:action="props">
                <v-btn icon @click="editItem(props.item)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon @click="deleteItem(props.item)"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
            <template v-slot:content="props">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{$utils.limitStringLength(props.item.content, 100)}}</span>
                    </template>
                    <span>{{props.item.content}}</span>
                </v-tooltip>
            </template>
        </SimpleDataTable>
        <SampleImportExcel ref="SampleImportExcel"></SampleImportExcel>
    </div>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable";
import { mapState } from "vuex";
import NLP_Service from "@/services/nlp.service";
import { ScenarioEventBus, ScenarioEventBusType } from "@/views/Scenario/scenario.eventbus";
import SampleImportExcel from "@/views/Scenario/nlp/SampleImportExcel";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "SampleList",
    components: { SampleImportExcel, SimpleDataTable },
    data () {
        return {
            intent: '',
            entity: '',
            content: '',
            pagination: {
                rowsPerPage: 10,
                page: 1
            }
        }
    },
    computed: {
        ...mapState({
            scenario: state => state.scenario.scenario,
            intentList: state => state.scenario.intentList,
            entityList: state => state.scenario.entityList,
            sampleList: state => state.scenario.sampleList
        }),
        filterSampleList () {
            let intent = this.intent.trim().toLowerCase()
            let entity = this.entity.trim().toLowerCase()
            let content = this.$utils.nonAccentVietnamese(this.content)
            return this.sampleList.filter(
                item => (
                    (!content || this.$utils.nonAccentVietnamese(item.content).includes(content)) &&
                    (!intent || item.intent_label.includes(intent)) &&
                    (!entity || item.entities.includes(entity))
                )
            )
        },
        sampleHeaders () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('content'),
                    value: 'content',
                    type: 'custom',
                    id: 'content'
                },
                {
                    text: this.$t('intent'),
                    value: 'intent_label'
                },
                {
                    text: this.$t('entity'),
                    value: 'entities',
                    $value: item => item.entities.join(', ')
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    id: 'action',
                    visible: this.isEditable
                }
            ])
        },
        isEditable: () => ScenarioService.isEditable()
    },
    methods: {
        filterItem ({ intent, entity, content }) {
            this.intent = intent ? intent : ''
            this.entity = entity ? entity : ''
            this.content = content ? content : ''
        },
        searchItem () {
            this.$store.dispatch(this.$actionTypes.scenario.GET_SAMPLE_LIST, this.$route.params.scenarioId)
        },
        createItem () {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_SAMPLE, {
                item: null,
                resolve: this.searchItem
            })
        },
        editItem (item) {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_SAMPLE, {
                item: item,
                resolve: this.searchItem
            })
        },
        deleteItem (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('sample') + ': ' + item.content })).then(
                () => {
                    let i18n = {
                        action: this.$t('delete'),
                        item: this.$t('sample')
                    }
                    this.$appService.showLoading()
                    NLP_Service.SampleService.delete(this.$route.params.scenarioId, item.code).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.searchItem()
                        },
                        this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                    ).finally(this.$appService.hideLoading)
                }
            )
        },
        importExcel () {
            this.$refs.SampleImportExcel.open().then(
                () => this.$store.dispatch(this.$actionTypes.scenario.GET_NLP, this.$route.params.scenarioId)
            )
        }
    },
    watch: {
        sampleList () {
            this.pagination = {
                rowsPerPage: 10,
                page: 1
            }
        }
    }
}
</script>

<style scoped>

</style>
